export default "__VITE_ASSET__a50317f1__"